// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '../mdbvuepro/node_modules/bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '../mdbvuepro/node_modules/@fortawesome/fontawesome-free/css/all.min.css'
import App from './App'
import store from './store'
import router from './router'
import Notify from 'mdbvue/lib/components/Notify'

Vue.config.productionTip = false
Vue.use(Notify)

Object.defineProperty(Vue.prototype, '$bus', {
  get: function () {
    return this.$root.bus
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    bus: new Vue({})
  },
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js